import { Box, Flex, Text } from '@chakra-ui/core'
import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { withAlpha } from 'utils'
import { isRtlSelector } from 'redux/selectors/general'
import { useAILoadingContext } from 'components/TasksV2/AITaskCreation/AIFormStepContext'
import GeneratingText from './GeneratingText'
import { AiAvatar } from 'components/CommonComponents/AIAvatar'

interface IAIMessageProps {
  title: string
  subtitle: string
  generatingTitle?: string
  generatingSubtitle?: string
}

const AIMessage: React.FC<IAIMessageProps> = memo(({ title, subtitle, generatingTitle, generatingSubtitle }) => {
  const theme = useSelector((state: RootState) => state.general.theme)
  const elementsColor = theme?.elementsColor || '#FF2D78'
  const isRtl = useSelector(isRtlSelector)
  const { isGenerating } = useAILoadingContext()

  const titleNode =
    isGenerating && generatingTitle ? (
      <GeneratingText text={generatingTitle} color="#111111" fontSize="16px" fontWeight="700" />
    ) : (
      <Text fontSize="16px" color="#111111" fontWeight="700">
        {title}
      </Text>
    )

  const subtitleNode =
    isGenerating && generatingSubtitle ? (
      <GeneratingText text={generatingSubtitle} color="#b8b8b8" fontSize="14px" fontWeight="400" />
    ) : (
      <Text fontSize="14px" color="#888888" fontWeight="400">
        {subtitle}
      </Text>
    )

  return (
    <Flex alignItems="flex-start" mb="40px">
      <AiAvatar listening={true} size={94} />
      <Box
        bg={withAlpha(elementsColor, 0.1)}
        borderRadius={isRtl ? '14px 4px 14px 14px' : '4px 14px 14px 14px'}
        px="30px"
        py="20px"
        mt="20px"
        maxW="80%"
        border={`1px solid ${withAlpha(elementsColor, 0.2)}`}
      >
        <Box mb="10px">{titleNode}</Box>
        {subtitleNode}
      </Box>
    </Flex>
  )
})

export default AIMessage
